module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wood@3x_4cd546.jpg";